import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=1c3ed398&scoped=true"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"
import style0 from "./Check.vue?vue&type=style&index=0&id=1c3ed398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ed398",
  null
  
)

export default component.exports